import React from "react";
import Page from "../../components/Page";
import Steps from "../../components/Generales/Steps";
import { Row, Col, } from "reactstrap";


const ContainerApAbierto = (props) => {

  

    return (

        <main class="cr-app bg-light">
            <div class="cr-content container-fluid">
                <div className="container-body-spaces">


                    <Page
                        title={props.titulo}
                        breadcrumbs={[{ name: props.titulo, active: true }]}
                    >
                        <Row>
                            <Col lg={8} md={12} sm={12} xs={12}>
                                <Steps tipo={'apAbierto'} paso={props.paso}></Steps>

                            </Col>
                        </Row>
                        {props.children}
                    </Page>
                </div>
            </div>
        </main>
    );
};
export default ContainerApAbierto;
